import React from 'react';
import {
  QuoteEmailComposeModal,
  QuoteEmailComposeModalProps
} from 'src/content/applications/quote/QuoteEmailComposeModal';

const EmailTemplateModal = (props: QuoteEmailComposeModalProps) => (
  <QuoteEmailComposeModal {...props} recipientsEditable emailType="DEPOSIT" ccSupported={true} />
);

export default EmailTemplateModal;
